{
  "title": "Configurar Fermin",
  "lead": "Escribe el código de activación que te dio tu administrador.",
  "codeLabel": "Código de activación",
  "help": "Seis letras o números, sin 0, O, 1 ni I. Vence a los 15 minutos y es de un solo uso.",
  "submit": "ACTIVAR",
  "submitting": "Activando…",
  "errors": {
    "invalid": "Código no válido o vencido",
    "rateLimited": "Demasiados intentos. Espera un momento",
    "suspended": "El servicio está suspendido. Contacta a tu empresa.",
    "network": "Sin conexión. Revisa la red de la sede e inténtalo de nuevo.",
    "unexpected": "No pudimos activar el marcador. Inténtalo de nuevo."
  },
  "configured": {
    "title": "✓ Marcador configurado",
    "lead": "Marcador configurado",
    "summary": "{company} · {site} · {terminal}",
    "companyLabel": "Empresa",
    "siteLabel": "Sede",
    "terminalLabel": "Marcador",
    "wakeLockHint": "Desactiva el bloqueo automático de pantalla",
    "continue": "Ir a la pantalla de sede"
  },
  "unlinked": {
    "title": "Este marcador fue desvinculado",
    "description": "Pide un código de activación nuevo a tu administrador y escríbelo aquí.",
    "siteInactive": "La sede de este marcador fue desactivada. Contacta a tu empresa."
  },
  "storageCleared": {
    "title": "Este marcador perdió su configuración",
    "description": "Pide un código de activación nuevo a tu administrador."
  }
}
